import { darken } from "../../../utils";

export function circleScale(o) {
	const cs = ["interpolate", ["linear"], ["zoom"]];
	o.scale.forEach((s) => {
		cs.push(s[0]);
		cs.push(["+", o.min, ["*", s[1], ["sqrt", ["number", ["get", o.key], 0]]]]);
	});
	return cs;
}

export function circleScaleFunction(o) {
	return function (val, z) {
		const v = Math.sqrt(val);
		let iz = o.scale.length;
		for (let i = o.scale.length - 1; i >= 0; i--) {
			if (z <= o.scale[i][0]) iz = i;
		}
		let f = 0;
		if (iz === 0) {
			f = o.scale[0][1];
		} else if (iz === o.scale.length) {
			f = o.scale[o.scale.length - 1][1];
		} else {
			f =
				((z - o.scale[iz - 1][0]) / (o.scale[iz][0] - o.scale[iz - 1][0])) * (o.scale[iz][1] - o.scale[iz - 1][1]) +
				o.scale[iz - 1][1];
		}
		window.iz = iz;
		return 2 * (o.min + f * v);
	};
}

export function circleCurrentKeyColors(key, values, colors, colorDeactivated) {
	const expr = [
		"match",
		["get", key],
		...values
			.map((item, i) => [
				item,
				[
					"case",
					["boolean", ["feature-state", "notActive"], false],
					colorDeactivated,
					["boolean", ["feature-state", "current"], false],
					darken(colors[i], 0.6),
					colors[i],
				],
			])
			.flat(), // colorDeactivated,
		/* other */ "#ccc",
	];
	return expr;
}

export function circleColors(key, values, colors, defaultColor) {
	const expr = [
		"match",
		["get", key],
		...values
			.map((item, i) => [
				item,
				["case", ["boolean", ["feature-state", "current"], false], darken(colors[i], 0.6), colors[i]],
			])
			.flat(), // colorDeactivated,
		["case", ["boolean", ["feature-state", "current"], false], darken(defaultColor, 0.6), defaultColor],
	];
	return expr;
}

export function circleCurrent(yes, no) {
	return ["case", ["boolean", ["feature-state", "current"], false], yes, no];
}

export function circleActive(yes, no) {
	return ["case", ["boolean", ["feature-state", "active"], false], yes, no];
}

export function switchMapCallback(switchKey, dataKey, colorDict, nonActiveColor, map) {
	return function callback(arg) {
		const ons = [];

		arg.forEach((item) => {
			ons.push(item[switchKey]);
		});
		// console.log(ons);
		if (ons.length > 0) {
			map.map.setPaintProperty(
				"points",
				"circle-color",
				circleColors(
					dataKey,
					ons,
					ons.map((el) => colorDict[el]),
					nonActiveColor
				)
			);
		} else {
			map.map.setPaintProperty("points", "circle-color", circleCurrent(darken(nonActiveColor, 0.6), nonActiveColor));
		}
	};
}

export function convertToGeoJSON(topojsonData) {
	const topojson = window.topojson;

	return topojson.feature(topojsonData, topojsonData.objects[Object.keys(topojsonData.objects)[0]]);
}
